<template>
  <!-- SMS Status Badge - Apple Glass Design -->
  <div class="inline-flex items-center gap-1.5 cursor-pointer" @click="$emit('click')">
    
    <!-- Main Status Badge -->
    <!-- Failed/Undelivered (Highest Priority) -->
    <span
      v-if="tracking.failed || tracking.status === 'failed' || tracking.status === 'undelivered'"
      class="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-semibold bg-red-500/20 text-red-300 border border-red-500/30"
      :class="tracking.errorMessage ? 'max-w-md' : 'whitespace-nowrap'"
      :title="tracking.errorMessage || 'SMS delivery failed'"
    >
      <svg class="w-3.5 h-3.5 mr-1.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
      </svg>
      <span v-if="tracking.errorMessage" class="line-clamp-2">{{ tracking.errorMessage }}</span>
      <span v-else>Failed</span>
      <span v-if="tracking.errorCode" class="ml-1 text-red-400">({{ tracking.errorCode }})</span>
    </span>
    
    <!-- Delivered (Success) -->
    <span
      v-else-if="tracking.delivered || tracking.status === 'delivered'"
      class="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-semibold bg-green-500/20 text-green-300 border border-green-500/30 whitespace-nowrap"
      title="Delivered"
    >
      <svg class="w-3.5 h-3.5 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
      </svg>
      Delivered
    </span>
    
    <!-- Sent (In Transit) -->
    <span
      v-else-if="tracking.sent || tracking.status === 'sent'"
      class="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-semibold bg-blue-500/20 text-blue-300 border border-blue-500/30 whitespace-nowrap"
      title="SMS sent to carrier"
    >
      <svg class="w-3.5 h-3.5 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
      </svg>
      Sent
    </span>
    
    <!-- Queued (Waiting) -->
    <span
      v-else-if="tracking.queued || tracking.status === 'queued'"
      class="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-semibold bg-yellow-500/20 text-yellow-300 border border-yellow-500/30 whitespace-nowrap"
      title="SMS queued for sending"
    >
      <svg class="w-3.5 h-3.5 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"/>
      </svg>
      Queued
    </span>
    
    <!-- No SMS / Unknown -->
    <span
      v-else
      class="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-semibold bg-gray-500/20 text-gray-400 border border-gray-500/30 whitespace-nowrap"
      title="No SMS tracking data"
    >
      <svg class="w-3.5 h-3.5 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
      </svg>
      No SMS
    </span>
    
  </div>
</template>

<script>
export default {
  name: 'SMSStatusBadge',
  props: {
    tracking: {
      type: Object,
      required: true,
      default: () => ({
        status: 'unknown',
        delivered: false,
        failed: false,
        sent: false,
        queued: false,
        errorCode: null,
        errorMessage: null,
        cost: 0,
        numSegments: 0
      })
    }
  },
  methods: {
    formatCost(cost) {
      if (!cost || cost === 0) return '';
      const amount = Math.abs(parseFloat(cost));
      return `$${amount.toFixed(3)}`;
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return dateString;
      }
    }
  }
};
</script>

